var map = {
	"./bridge/bridge_loader.svg": "a3a8",
	"./dankoff/dankoff_loader.svg": "4743",
	"./dobby/dobby_loader.svg": "552b",
	"./hermelin/hermelin_loader.svg": "f439",
	"./lacava/lacava_loader.svg": "f5a1",
	"./selecta/selecta_loader.svg": "f0eb",
	"./slow/slow_loader.svg": "b012",
	"./verdi/verdi_loader.svg": "d6ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0d6a";